import React from 'react'
import styled from 'styled-components'

import { selectUserInfoCollapsed } from 'state/futures/common/selectors'
import { useAppSelector } from 'state/hooks'
import media, { HEIGHT_BREAKPOINTS } from 'styles/media'

import MarketDetails from '../MarketDetails'
import { MARKETS_DETAILS_HEIGHT_DESKTOP } from '../styles'
import UserInfo from '../UserInfo'

import ChartWrapper from './ChartWrapper'

const MarketInfo: React.FC = React.memo(() => {
	const userInfoCollapsed = useAppSelector(selectUserInfoCollapsed)
	return (
		<Container userInfoCollapsed={userInfoCollapsed}>
			<MarketDetails />
			<ChartWrapper />
			<UserInfo />
		</Container>
	)
})

const Container = styled.div<{ showBanner?: boolean; userInfoCollapsed: boolean }>`
	height: 100%;
	width: 100%;
	overflow: hidden;
	display: grid;
	grid-template-rows: ${MARKETS_DETAILS_HEIGHT_DESKTOP}px 1fr ${({ userInfoCollapsed }) =>
			userInfoCollapsed ? '40px' : '340px'};
	${({ userInfoCollapsed }) => media.lessThan('xl')`
		grid-template-rows: ${MARKETS_DETAILS_HEIGHT_DESKTOP}px 1fr ${userInfoCollapsed ? '40px' : '250px'};
	`}
	@media (max-height: ${HEIGHT_BREAKPOINTS.xl}px) {
		grid-template-rows: ${MARKETS_DETAILS_HEIGHT_DESKTOP}px 1fr ${({ userInfoCollapsed }) =>
				userInfoCollapsed ? '40px' : '250px'};
	}

	transition: grid-template-rows 0.4s ease-out;
`

export default MarketInfo
